import React from 'react';
import { t } from '@lingui/macro';

import SimplifiedPriceColumn from '@rover/components/src/cards/SearchResultCard/PriceColumn/SimplifiedPriceColumn';
import DropdownSmall from '@rover/icons/svg/dropdown-small.svg';
import { Button } from '@rover/kibble/core';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { SitterProfileVersionOptions } from '../../constants';
import { useRevampCta } from '../../hooks/useRevampCta';
import { useRevampCtaCommon } from '../../hooks/useRevampCtaCommon';
import AdditionalRatesSection from '../ServiceSection/AdditionalRatesSection';

import { SitterProfileSeeAllRatesClicked } from './analyticsEvents';
import { CTAProps } from './RevampServicesCta';

type Props = {
  handleOpenSheet: () => void;
};

const RevampMobileCtaBarCommon = ({
  handleOpenSheet,
  priceTransparencyLevel,
  language,
  petCount,
  petType,
}: Props & Omit<CTAProps, 'bookingFeePercentage'>): JSX.Element => {
  const { sitterData, serviceType, standardRate, serviceDisplayName, serviceIsAway } =
    useRevampCta();
  const { price, isPetCareModes } = useRevampCtaCommon(
    priceTransparencyLevel,
    petType,
    petCount,
    standardRate
  );
  return (
    <>
      <Button
        variant="link"
        size="default"
        icon={DropdownSmall}
        iconAlignment="right"
        onPress={handleOpenSheet}
        aria-label={
          serviceDisplayName ? t`Select a service: ${serviceDisplayName}` : t`Select a service`
        }
        padding="0x"
        sx={{
          color: serviceIsAway ? 'text.disabled' : 'text.primary',
        }}
      >
        {serviceDisplayName ?? t`Select a service`}
      </Button>

      {standardRate && price && (
        <AdditionalRatesSection
          services={sitterData.services}
          isSitterInPetCareModesExperiment={isPetCareModes}
          priceTransparencyLevel={priceTransparencyLevel}
          isCtaModal
          isRevampVersion
          renderTrigger={(toggleModal) => (
            <SimplifiedPriceColumn
              variant="cta-mobile"
              currencyCode={standardRate.pricePerUnitObj.currencyIso}
              priceTransparencyLevel={priceTransparencyLevel}
              language={language}
              price={price}
              priceInCredits={0}
              shouldShowPriceInCredits={false}
              showFromText
              unitAsSentence={standardRate.unitAsSentence}
              isBHUser={false}
              onPriceClick={() => {
                emitAnalyticsEvent(
                  new SitterProfileSeeAllRatesClicked({
                    serviceSlug: serviceType ?? '',
                    pageVariant: SitterProfileVersionOptions.REVAMP,
                  })
                );
                toggleModal();
              }}
            />
          )}
        />
      )}
    </>
  );
};

export default RevampMobileCtaBarCommon;
